/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';
export let ngTap:any[] = [() => {
    class NgTapDirective {
        link($scope, $element, $attrs) {
            if ('ontouchend' in document) {
                $element.bind('touchend', function () {
                    $scope.$apply($attrs.ngTap);
                });
            } else {
                $element.bind('click', function () {
                    $scope.$apply($attrs.ngTap);
                });
            }
        }
    }
    return new NgTapDirective();
}]


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/ng-tap.directive.ts